import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";

import {map} from "rxjs/operators";

import {AccessService} from "./services/access.service";
import {DataService} from "./services/data.service";

export const ClientGuard: CanActivateFn = (route, state) => {

    const accessService = inject(AccessService);
    const dataService = inject(DataService);
    const router = inject(Router);

    return dataService.request("Client/getConfig").pipe(
        map((response: any) => {
            if (response.config) {
                accessService.client = response.config;
                return true;
            } else {
                router.navigate(["/denied"]);
                return false;
            }
        })
    );
};
